import image1 from "assests/projects/p1.jpg";
import image2 from "assests/projects/p2.jpg";
import image3 from "assests/projects/p3.jpg";

const projectsData = [
  {
    image: image1,
    title: "hawiyah gas development pk16",
    project_client: "client test",
    project_brief: "project brief",
    project_period: "2 years",
    year: "1920",
  },
  {
    image: image2,
    title: "ubtg - 4 extensions & bjbfg - 3 pipeline saudi aramco ltd",
    project_client: "client test",
    project_brief: "project brief",
    project_period: "2 years",
    year: "1920",
  },
  {
    image: image3,
    title:
      "ubtg - 3 pipeline, uthamaniyah gas plant contract no.44250/00 (ik) bi-8266 & 8270",
    project_client: "client test",
    project_brief: "project brief",
    project_period: "2 years",
    year: "2001",
  },
  {
    image: image1,
    title: "hawiyah gas development pk16",
    project_client: "client test",
    project_brief: "project brief",
    project_period: "2 years",
    year: "2010",
  },
  {
    image: image2,
    title: "ubtg - 4 extensions & bjbfg - 3 pipeline saudi aramco ltd",
    project_client: "client test",
    project_brief: "project brief",
    project_period: "2 years",
    year: "2020",
  },
  {
    image: image3,
    title:
      "ubtg - 3 pipeline, uthamaniyah gas plant contract no.44250/00 (ik) bi-8266 & 8270",
    project_client: "client test",
    project_brief: "project brief",
    project_period: "2 years",
    year: "2024",
  },
];

export default projectsData;
